import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const listArtsCustom = /* GraphQL */ `
  query ListArtsCustom(
    $filter: ModelArtFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listArts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        user {
          email
        }
        createdAt
        like
      }
      nextToken
    }
  }
` as GeneratedQuery<APITypes.ListArtsQueryVariables, APITypes.ListArtsQuery>;

export const listArtsCustom2 = /* GraphQL */ `
  query listArtsCustom2(
    $filter: ModelArtFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listArts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        s3Image {
          key
        }
      }
      nextToken
      __typename
    }
  }
` as GeneratedQuery<APITypes.ListArtsQueryVariables, APITypes.ListArtsQuery>;

export const getArtCustom = /* GraphQL */ `
  query getArtCustom($id: ID!) {
    getArt(id: $id) {
      id
      user {
        email
      }
      like
    }
  }
` as GeneratedQuery<APITypes.GetArtQueryVariables, APITypes.GetArtQuery>;

export const getArtCustom2 = /* GraphQL */ `
  query getArtCustom2($id: ID!) {
    getArt(id: $id) {
      id
      user {
        username
        email
      }
      createdAt
      subject
      subOption
      feeling
      medium
      styles
      color
      s3Image {
        key
      }
      like
      approve
      deleted
    }
  }
` as GeneratedQuery<APITypes.GetArtQueryVariables, APITypes.GetArtQuery>;

export const getArtCustom3 = /* GraphQL */ `
  query getArtCustom3($id: ID!) {
    getArt(id: $id) {
      user {
        username
      }
      createdAt
      subject
      subOption
      feeling
      medium
      styles
      color
      s3Image {
        key
      }
    }
  }
` as GeneratedQuery<APITypes.GetArtQueryVariables, APITypes.GetArtQuery>;

export const artsByUserIdAndCreatedAtCustom = /* GraphQL */ `
query artsByUserIdAndCreatedAtCustom(
  $userId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelArtFilterInput
  $limit: Int
  $nextToken: String
) {
  artsByUserIdAndCreatedAt(
    userId: $userId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userId
      createdAt
      user {
        id
        email
        username
        identityId
      }
      title
    }
    nextToken
  }
}
` as GeneratedQuery<
  APITypes.ArtsByUserIdAndCreatedAtQueryVariables,
  APITypes.ArtsByUserIdAndCreatedAtQuery
>;

export const ordersByInvoiceNumberCustom = /* GraphQL */ `
  query ordersByInvoiceNumberCustom(
    $invoiceNumber: String!
    $filter: ModelOrderFilterInput
  ) {
    ordersByInvoiceNumber(
      invoiceNumber: $invoiceNumber
      filter: $filter
    ) {
      items {
        id
        createdAt
        invoiceNumber
        invoiceId
        receiptNumber
        email
        status
        fulfillment_tracking_id
        fulfillment_method
        fulfillment_status
        fulfillment_createdAt
        fulfillment_updatedAt
        fulfillment_completedAt
      }
    }
  }
` as GeneratedQuery<
  APITypes.OrdersByInvoiceNumberQueryVariables,
  APITypes.OrdersByInvoiceNumberQuery
>;

export const usersByEmailCustom = /* GraphQL */ `
  query UsersByEmailCustom(
    $email: String!
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    usersByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        email
        emailVerified
        identityId
        credits
        boughtCredits
        creditPurchases {
          items {
            id
            createdAt
            user {
              id
              createdAt
              email
              emailVerified
              identityId
              credits
              boughtCredits
              updatedAt
              __typename
            }
            creditAmount
            checkoutSessionId
            paymentIntentId
            updatedAt
            userCreditPurchasesId
            __typename
          }
          nextToken
          __typename
        }
        orders {
          items {
            id
            createdAt
            user {
              id
              createdAt
              email
              emailVerified
              identityId
              credits
              boughtCredits
              updatedAt
              __typename
            }
            stripeCustomerId
            invoiceNumber
            invoiceId
            receiptNumber
            email
            status
            cost_total
            cost_taxes
            cost_shipping
            couponId
            coupon_amount_off
            coupon_name
            discountId
            discount_amount
            promotionID
            promotion_code
            fulfillment_tracking_id
            fulfillment_method
            fulfillment_status
            fulfillment_createdAt
            fulfillment_updatedAt
            fulfillment_completedAt
            billing_name
            billing_address
            billing_address2
            billing_city
            billing_state
            billing_zip
            billing_country
            shipping_name
            shipping_address
            shipping_address2
            shipping_city
            shipping_state
            shipping_zip
            shipping_country
            shipping_phone
            notes
            vendor
            order_source
            currency
            cancel
            updatedAt
            userOrdersId
            orderCartId
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
` as GeneratedQuery<
  APITypes.UsersByEmailQueryVariables,
  APITypes.UsersByEmailQuery
>;

export const ordersByEmailAndCreatedAtCustom = /* GraphQL */ `
  query OrdersByEmailAndCreatedAtCustom(
    $email: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ordersByEmailAndCreatedAt(
      email: $email
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        invoiceNumber
        receiptNumber
        email
        cost_total
        discount_amount
        currency
        userOrdersId
        orderCartId
        __typename
      }
      nextToken
      __typename
    }
  }
` as GeneratedQuery<
  APITypes.OrdersByEmailAndCreatedAtQueryVariables,
  APITypes.OrdersByEmailAndCreatedAtQuery
>;

export const getUserCustom = /* GraphQL */ `
  query GetUserCustom($id: ID!) {
    getUser(id: $id) {
      email
      identityId
      credits
      stripeCustomerId
    }
  }
` as GeneratedQuery<APITypes.GetUserQueryVariables, APITypes.GetUserQuery>;
